"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayVerticalNav = void 0;

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _shared = require("@clayui/shared");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _reactTransitionGroup = require("react-transition-group");

var _warning = _interopRequireDefault(require("warning"));

var _Nav = _interopRequireDefault(require("./Nav"));

var _Trigger = _interopRequireDefault(require("./Trigger"));

var _excluded = ["active", "href", "initialExpanded", "items", "label", "level", "onClick", "spritemap"],
    _excluded2 = ["activeLabel", "decorated", "items", "large", "spritemap", "trigger", "triggerLabel"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Item(_ref) {
  var active = _ref.active,
      href = _ref.href,
      _ref$initialExpanded = _ref.initialExpanded,
      initialExpanded = _ref$initialExpanded === void 0 ? false : _ref$initialExpanded,
      subItems = _ref.items,
      label = _ref.label,
      level = _ref.level,
      _onClick = _ref.onClick,
      spritemap = _ref.spritemap,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = _react.default.useState(!initialExpanded),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpaned = _React$useState2[1];

  return /*#__PURE__*/_react.default.createElement(_Nav.default.Item, otherProps, /*#__PURE__*/_react.default.createElement(_Nav.default.Link, {
    active: active,
    collapsed: !expanded,
    href: href,
    onClick: function onClick() {
      setExpaned(!expanded);

      if (_onClick) {
        _onClick();
      }
    },
    role: "button",
    showIcon: !!subItems,
    spritemap: spritemap
  }, label), subItems && /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    className: expanded ? undefined : 'collapse',
    classNames: {
      enter: 'collapsing',
      enterActive: "show",
      enterDone: 'show',
      exit: "show",
      exitActive: 'collapsing'
    },
    in: expanded,
    onEnter: function onEnter(element) {
      return element.setAttribute('style', "height: 0px");
    },
    onEntering: function onEntering(element) {
      return (0, _shared.setElementFullHeight)(element);
    },
    onExit: function onExit(element) {
      return (0, _shared.setElementFullHeight)(element);
    },
    onExiting: function onExiting(element) {
      return element.setAttribute('style', "height: 0px");
    },
    timeout: 250
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Nav.default, {
    stacked: true
  }, renderItems(subItems, spritemap, level++)))));
}

function renderItems(items, spritemap) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return items.map(function (item, i) {
    var key = "".concat(level, "-").concat(i);
    return /*#__PURE__*/_react.default.createElement(Item, _extends({}, item, {
      key: key,
      level: level,
      spritemap: spritemap
    }));
  });
}

var ClayVerticalNav = function ClayVerticalNav(_ref2) {
  var _classNames;

  var activeLabel = _ref2.activeLabel,
      decorated = _ref2.decorated,
      items = _ref2.items,
      large = _ref2.large,
      spritemap = _ref2.spritemap,
      _ref2$trigger = _ref2.trigger,
      CustomTrigger = _ref2$trigger === void 0 ? _Trigger.default : _ref2$trigger,
      _ref2$triggerLabel = _ref2.triggerLabel,
      triggerLabel = _ref2$triggerLabel === void 0 ? 'Menu' : _ref2$triggerLabel,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  var _React$useState3 = _react.default.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      active = _React$useState4[0],
      setActive = _React$useState4[1];

  "production" !== "production" ? (0, _warning.default)(!activeLabel, 'ClayVerticalNav: The `activeLabel` API has been deprecated in favor of `triggerLabel` and will be removed in the next major release.') : void 0;
  return /*#__PURE__*/_react.default.createElement("nav", _extends({}, otherProps, {
    className: (0, _classnames.default)('menubar menubar-transparent', (_classNames = {}, _defineProperty(_classNames, 'menubar-decorated', decorated), _defineProperty(_classNames, 'menubar-vertical-expand-lg', large), _defineProperty(_classNames, 'menubar-vertical-expand-md', !large), _classNames))
  }), /*#__PURE__*/_react.default.createElement(CustomTrigger, {
    onClick: function onClick() {
      return setActive(!active);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "inline-item inline-item-before"
  }, activeLabel || triggerLabel), /*#__PURE__*/_react.default.createElement(_icon.default, {
    focusable: "false",
    role: "presentation",
    spritemap: spritemap,
    symbol: "caret-bottom"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('collapse menubar-collapse', {
      show: active
    })
  }, /*#__PURE__*/_react.default.createElement(_Nav.default, {
    nested: true
  }, renderItems(items, spritemap))));
};

exports.ClayVerticalNav = ClayVerticalNav;
ClayVerticalNav.Trigger = _Trigger.default;